import { CustomError } from './custom-error';

export class ContractNotDeployingError extends CustomError {
  constructor({ message = 'Contract is not deploying.', data, name = 'INVALID_PROVIDER' }: { message?: string; data?: unknown; name?: string } = {}) {
    super({ message, data, name });

    Object.setPrototypeOf(this, ContractNotDeployingError.prototype);
  }
}
